const getCard = (amount, userClass, { cards, purchaseLimits }) => {
	if (amount >= purchaseLimits[userClass].max)
		return userClass === 'investor' ? cards['royal'] : cards['exclusive'];
	return (
		cards[
			Object.values(cards)
				.filter((c) => c.type === userClass)
				.map((c) => c.name)
				.find((c) => amount < cards[c].max && amount >= cards[c].min)
		] || cards['white']
	);
};

export default getCard;
